var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15778",
    "data-name": "Rectangle 15778",
    width: 18.748,
    height: 22.934,
    fill: "#878a99",
    stroke: "#878a99",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40175",
    "data-name": "Group 40175",
    transform: "translate(-755 -724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15779",
    "data-name": "Rectangle 15779",
    transform: "translate(755 724)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40174",
    "data-name": "Group 40174",
    transform: "translate(760 727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40173",
    "data-name": "Group 40173",
    transform: "translate(-2 -2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82673",
    "data-name": "Path 82673",
    d: "M6.968,19.387a1.606,1.606,0,0,1-.791-.718q-2.322-3.531-4.654-7.056A9.166,9.166,0,0,1,.094,8.186,6.358,6.358,0,0,1,.1,5.967,7.027,7.027,0,0,1,2.084,2.116,6.918,6.918,0,0,1,5.519.2a6.984,6.984,0,0,1,5.248.792A7.016,7.016,0,0,1,13.98,5a6.715,6.715,0,0,1-.053,4.342,9.819,9.819,0,0,1-1.115,2.243q-2.332,3.547-4.673,7.089a1.606,1.606,0,0,1-.792.718Zm.187-.81c.07-.092.123-.153.166-.219q2.4-3.636,4.8-7.275a8.787,8.787,0,0,0,.93-1.81,5.962,5.962,0,0,0,.24-3.6,6.236,6.236,0,0,0-2.912-3.932A6.13,6.13,0,0,0,6.917.862a6.105,6.105,0,0,0-2.875.817A6.216,6.216,0,0,0,1.157,5.213a5.7,5.7,0,0,0-.22,2.85,8.189,8.189,0,0,0,1.272,3.045q2.382,3.626,4.779,7.242c.044.067.1.13.167.226",
    transform: "translate(1.773 1.773)",
    fill: "#878a99",
    stroke: "#878a99",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82674",
    "data-name": "Path 82674",
    d: "M54.88,58.72a3.79,3.79,0,1,1,3.779-3.814A3.788,3.788,0,0,1,54.88,58.72m-.007-6.734a2.946,2.946,0,1,0,2.946,2.951,2.96,2.96,0,0,0-2.946-2.951",
    transform: "translate(-45.94 -45.993)",
    fill: "#878a99",
    stroke: "#878a99",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fe8e40aeb897b2dc03e710b2e5e891c3.svg";
export { ForwardRef as ReactComponent };